/**
 * The utility file for shared functions.
 *
 * Contains:
 *   cleanCategory: Sanitizes a single category for spaces.
 *   cleanTags: Sanitizes an array of tags for spaces.
 *
 */

// unused
export const cleanCategory = (category) => {
  return category.replace(/ /g, "_")
}

export const cleanArrayTags = (tags) => {
  return tags.map(tag => tag.replace(/ /g, "_"))
}

export const cleanGroupTags = (group) => {
  return group.map( tag => {
      const obj = Object.assign({}, tag)
      obj["fieldValue"] = obj["fieldValue"].replace(/ /g, "_")
      return obj
    })
}
